/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The helper to map received data to chart dynamic data
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

import moment from 'moment';

import { EChartDataKeyEnum, IChartDataInput } from '../../../components/common/Chart/chartTypes';
import ICommonTranslationCalendar from '../../../modules/internationalization/types/common/calendar';
import { EFormatData } from '../../PageDashboard/types/widgetTypes';
import {
    EExpensesAnalyzerField,
    IExpensesAnalyzerData,
    IExpensesAnalyzerDataDetails,
} from '../components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { TChartIdField } from '../types/pageExpensesAnalyzerTypes';

export const mapTableDataToChartDynamicData =
    (tableData: IExpensesAnalyzerData[], calendar: ICommonTranslationCalendar,
     chartIdField: TChartIdField): IChartDataInput[] => Object.values(
        tableData.reduce((r, a, i) => {
            r[a[chartIdField]] = r[a[chartIdField]] || {};
            r[a[chartIdField]][EChartDataKeyEnum.checked] = true;
            r[a[chartIdField]][EChartDataKeyEnum.order] = i;
            r[a[chartIdField]][EChartDataKeyEnum.total] = a[EExpensesAnalyzerField.AMOUNT_TOTAL];
            r[a[chartIdField]][EChartDataKeyEnum.x] = a[chartIdField];

            a[EExpensesAnalyzerField.DETAILS].forEach((detail: IExpensesAnalyzerDataDetails) => {

                const month = `${calendar.months[+moment(detail.month).format(EFormatData.OnlyMonth) - 1]}
                 ${moment(detail.month).format(EFormatData.OnlyYear)}`;

                r[a[chartIdField]][EChartDataKeyEnum.y] =
                    r[a[chartIdField]][EChartDataKeyEnum.y] || {};

                r[a[chartIdField]][EChartDataKeyEnum.y][month] =
                    detail[EExpensesAnalyzerField.AMOUNT_TOTAL];
            });
            return r;
        }, Object.create(null)),
    );
